import React from 'react';
import { PageTitle } from '../components/PageTitle';
export function SitemapXML() {
  // Get the current domain dynamically or use a default
  const domain = 'https://katalinabock.com';
  // XML content for the sitemap
  const xmlContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>${domain}/</loc>
    <changefreq>monthly</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>${domain}/about</loc>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/portfolio</loc>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/contact</loc>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>${domain}/case-study-1</loc>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/case-study-2</loc>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/case-study-3</loc>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/case-study-4</loc>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/case-study-5</loc>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/case-study-6</loc>
    <changefreq>monthly</changefreq>
    <priority>0.7</priority>
  </url>
  <url>
    <loc>${domain}/terms</loc>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>
  <url>
    <loc>${domain}/privacy</loc>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>
  <url>
    <loc>${domain}/sitemap</loc>
    <changefreq>monthly</changefreq>
    <priority>0.4</priority>
  </url>
</urlset>`;
  return <div className="container mx-auto px-4 py-12" data-id="element-1457">
      <PageTitle title="XML Sitemap" data-id="element-1458" />
      <div className="max-w-4xl mx-auto bg-gray-50 p-8 rounded-lg" data-id="element-1459">
        <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1460">XML Sitemap</h1>
        <p className="mb-4 text-gray-700" data-id="element-1461">
          This is the XML sitemap for your website. Search engines like Google
          use this file to more intelligently crawl your site.
        </p>
        <div className="bg-white p-6 rounded border border-gray-200 overflow-auto" data-id="element-1462">
          <pre className="text-xs text-gray-800 whitespace-pre-wrap" data-id="element-1463">
            {xmlContent}
          </pre>
        </div>
        <p className="mt-4 text-gray-600 text-sm" data-id="element-1464">
          To use this sitemap, replace "katalinabock.com" with your actual
          domain name.
        </p>
      </div>
    </div>;
}